module.exports = __webpack_public_path__ + "img/User-Solid.b352b497.svg";